export const returnDayOption = (year, month) => {
  const dayArr = [];
  const maxDays = new Date(year, month, 0).getDate();
  for (let index = 1; index <= maxDays; index += 1) {
    dayArr.push({
      value: `${index < 10 ? '0' : ''}${index}`,
      text: `${index < 10 ? '0' : ''}${index}`,
    });
  }
  return dayArr;
};

export const monthOption = [
  { value: '01', text: 'Jan' },
  { value: '02', text: 'Feb' },
  { value: '03', text: 'Mar' },
  { value: '04', text: 'Apr' },
  { value: '05', text: 'May' },
  { value: '06', text: 'Jun' },
  { value: '07', text: 'Jul' },
  { value: '08', text: 'Aug' },
  { value: '09', text: 'Sep' },
  { value: '10', text: 'Oct' },
  { value: '11', text: 'Nov' },
  { value: '12', text: 'Dec' },
];
export const returnYearOption = () => (
  [new Date().getFullYear().toString(), (new Date().getFullYear() + 1).toString()]
);
